import React from "react";
import PropTypes from "prop-types";
import { Link, withRouter } from "react-router-dom";

import styled from "styled-components";

// import { Button } from '../..';
import urlPatterns from "../../../urls";

import { fonts } from "../../../styles/variables";

// import facebookIcon from '../../../assets/images/icons/facebook-login-icon.svg';
// import googleIcon from '../../../assets/images/icons/google-login-icon.svg';

// const StyledSocialButtonsHolder = styled.div`
//   margin: 0 0 20px 0;
//   text-align: center;
//   > button,
//   a {
//     &:not(:last-child) {
//       margin-right: 10px;
//     }
//     background-color: ${colors.white};
//     color: ${colors.black};
//     border-color: ${colors.white};
//     display: inline-flex;
//     align-items: center;
//     padding: 16px 25px;
//     font-size: 12px;
//     ${breakpoints.xsDown} {
//       padding: 16px 18px;
//     }
//     &:hover,
//     &:focus {
//       background-color: ${colors.white};
//       border-color: ${colors.white};
//       color: ${colors.black};
//     }
//   }
// `;

// export const StyledSocialButtonIcon = styled.img`
//   width: 100px;
//   max-width: 24px;
//   display: inline-block;
//   margin-right: 14px;
//   ${breakpoints.xsDown} {
//     margin-right: 5px;
//   }
// `;
//
// const StyledSocialTitle = styled.h4`
//   font-size: 20px;
//   font-family: ${fonts.fontInterstateBlackCompressed};
//   margin: 0 0 20px 0;
//   text-align: center;
// `;

const StyledSocialHaveAccount = styled.p`
  margin: 20px 0 10px 0;
  font-size: 12px;
  text-align: center;
`;

const StyledTermsAndPrivacyConsent = styled.p`
  margin: 5px auto 30px auto;
  font-size: 12px;
  text-align: center;
  max-width: 600px;
  line-height: 20px;
`;

const StyledTermsAndPrivacyLink = styled(Link)`
  text-decoration: underline;
`;

const StyledSocialSignInLink = styled(Link)`
  font-family: ${fonts.fontInterstateUltraBlack};
  font-size: 11px;
  letter-spacing: 1.1px;
  text-transform: uppercase;
  display: inline-block;
  margin-left: 4px;
`;

const SignUpSocial = ({
  displayConsent = false,
  text = "Already have an account?",
  linkText = "Sign in",
  linkPath = urlPatterns.LOGIN,
  quizData = null,
  redirectUrl = null,
  _title = "or sign up with",
}) => (
  <>
    {/* <StyledSocialTitle>{title}</StyledSocialTitle> /}
      {/* <StyledSocialButtonsHolder> */}
    {/*   <Button> */}
    {/*   <StyledSocialButtonIcon src={facebookIcon} alt="facebookIcon" /> */}
    {/*   Facebook */}
    {/*   </Button> */}

    {/*   <Button> */}
    {/*   <StyledSocialButtonIcon src={googleIcon} alt="googleIcon" /> */}
    {/*    google */}
    {/*   </Button> */}
    {/* </StyledSocialButtonsHolder> */}
    {displayConsent && (
      <StyledTermsAndPrivacyConsent>
        By providing your email and proceeding it tells us that you happily accept our{" "}
        <StyledTermsAndPrivacyLink to={urlPatterns.TERMS}>Terms of Use</StyledTermsAndPrivacyLink> and
        acknowledge our{" "}
        <StyledTermsAndPrivacyLink to={urlPatterns.PRIVACY}>Privacy Policy</StyledTermsAndPrivacyLink>. In
        doing so we may also send you some helpful wine tips, product information and exclusive offers.
      </StyledTermsAndPrivacyConsent>
    )}
    <StyledSocialHaveAccount>
      {text}
      <StyledSocialSignInLink to={{ pathname: linkPath, state: { quizData, redirectUrl } }}>
        {linkText}
      </StyledSocialSignInLink>
    </StyledSocialHaveAccount>
  </>
);

SignUpSocial.propTypes = {
  title: PropTypes.string, // eslint-disable-line react/no-unused-prop-types
  displayConsent: PropTypes.bool,
  text: PropTypes.string,
  linkText: PropTypes.string,
  linkPath: PropTypes.string,
  quizData: PropTypes.shape({}),
  history: PropTypes.shape({}).isRequired,
  redirectUrl: PropTypes.string,
};

export default withRouter(SignUpSocial);
